// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"l3-z","yourQuestionLabel":"m3-z","notAuthedMessage":"n3-z","form":"o3-z","textarea":"p3-z","error":"q3-z","disabled":"r3-z","edited":"s3-z","submit":"t3-z"};